import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/membership/MembershipContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Box/Box.js");
